import React from 'react'
import { Tooltip } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

import { Container, StButton, WrapperTr } from './panel-body-style'
import type { PanelBodyProps } from './types'

function PanelBody({
  setItem,
  item,
  setId,
  setDrawerOpen,
  setGalView,
  attachments,
  editPermission,
  isNotUpload,
}: PanelBodyProps) {
  const { t } = useTranslation()

  const count = attachments?.length ?? 0
  const displayName = 'name' in item ? item.name : ''

  const handleUploadClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setItem(item)
    setId('id' in item ? (item.id as string) : undefined)
    setDrawerOpen(true)
  }

  return (
    <Container>
      <WrapperTr>
        <Container.Flex>
          {displayName + ' ( ' + count + ' )'}
        </Container.Flex>
      </WrapperTr>

      <WrapperTr>
        {!isNotUpload && (
          <div className="iconsWrapper">
            <Tooltip
              zIndex={9999}
              placement="top"
              title={t('upload_files')}
              color="blue"
            >
              <StButton onClick={handleUploadClick}>
                <PlusOutlined className="text-base" />
                <span>{t('upload_files')}</span>
              </StButton>
            </Tooltip>
          </div>
        )}
      </WrapperTr>
    </Container>
  )
}

export default React.memo(PanelBody)
